var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var PolicyTrendsIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 42
  }), React.createElement("path", {
    d: "M21 0.432373C9.75231 0.432373 0.542603 9.63106 0.542603 20.8898C0.542603 32.1486 9.74129 41.3473 21 41.3473C32.2588 41.3473 41.4575 32.1486 41.4575 20.8898C41.4575 9.63106 32.2588 0.432373 21 0.432373ZM16.5715 32.1376L6.34824 21.9143L9.75231 18.5103L16.5715 25.3294L30.2098 11.6911L33.6138 15.0952L16.5715 32.1376Z"
  }));
};
export var PolicyTrendsIconGlyph = function (props) {
  return React.createElement(PolicyTrendsIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};